export const GRAPHQL_VARIABLES = {
  contentType: 'image/png'
};

export const QUERY = `
  query GetUploadUrl($contentType: String!){
    getCompanyImgUploadUrl(contentType: $contentType) {
        url
    }
}
`;
